module.exports = __webpack_public_path__ + "static/media/html-on-page.bcb26093.jpg";